import KCBBD from "../../../phan-he-tiep-nhan-thanh-toan/components/tab-tiep-nhan/insurance-check-button/components/KCBBD";
import ChanDoan from "./custom-component/ChanDoan";
import ThaoTacGGT from "./custom-component/ThaoTacGGT";
import clsx from "clsx";

const TabsCustomComponent = ({ data }: any) => {
    const components: { [key: string]: any } = {
        chanDoan: <ChanDoan
            rowClassName="ps-0"
            endRowClassName='pe-0'
            containerClassName={clsx("W-900 pt-8", data?.properties?.containerClassName)}
            formName={data?.modelID}
            isView={data?.isView}
        />,
        benhVien: <KCBBD
            containerClassName="W-900 pt-8"
            widthInputCode={225}
            disabled={data?.isView}
        />,
        thaoTacGGT: <ThaoTacGGT formName={data?.modelID} isView={data?.isView} />
    };

    const DynamicContent = components[data?.componentName];

    return <>{DynamicContent}</>;
};

export default TabsCustomComponent;
